/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon20Light = forwardRef('UiCursorAIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.005 3.766c.001-1.442 1.649-2.263 2.801-1.397l9.958 7.487c1.344 1.01.628 3.15-1.053 3.148L10.73 13a.75.75 0 0 0-.6.3L7.14 17.277c-1.01 1.344-3.15.628-3.149-1.054l.015-12.458Zm2.2-.597a.75.75 0 0 0-1.2.598L4.99 16.225c0 .721.917 1.028 1.35.452l2.992-3.98a1.75 1.75 0 0 1 1.4-.698l4.98.005c.72.001 1.027-.916.451-1.35L6.205 3.17Z" })));
});
